<template>
  <div class="container">
    <history-dialog :visible.sync="historyDialogVisible" :employee-id="currentEmployeeId" />

    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>基础信息</el-breadcrumb-item>
        <el-breadcrumb-item>员工信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">员工信息（在职）</div>
    <el-card class="box-card">
      <div class="table-header">
        <div>
          <el-radio-group
            v-model="tabPosition"
            style="margin-bottom: 20px"
            @change="handleTabChange"
          >
            <el-radio-button label="在职">在职</el-radio-button>
            <el-radio-button label="离职">离职</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <el-button type="primary" size="small" @click="handleAdd" :disabled="!canEdit"
            >添加</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
        v-loading="loading"
      >
        <el-table-column label="序号1" align="center" type="index" width="80"> </el-table-column>
        <el-table-column prop="name" label="姓名" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gender" label="性别" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.gender || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="birth_year" label="出生年月" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.birth_year || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id_card" label="身份证" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.id_card || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="电话" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.phone || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="entry_date" label="入职日期" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.entry_date || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="leave_date" label="离职日期" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.leave_date || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="entry_attr_date" label="入职属性日期" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.entry_attr_date || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.status || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-dropdown @command="(command) => handleCommand(command, scope.row)">
              <span class="el-dropdown-link">
                更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit" :disabled="!canEdit">编辑</el-dropdown-item>
                <el-dropdown-item
                  command="delete"
                  :disabled="!isAuthorizedUser() || scope.row.status !== '离职' || !canEdit"
                  >删除</el-dropdown-item
                >
                <el-dropdown-item command="history">历史记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageParams.skip"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageParams.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 添加/编辑员工抽屉 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="formData"
          :rules="rules"
          ref="employeeForm"
          label-width="130px"
          label-position="right"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="formData.gender" placeholder="请选择性别" style="width: 100%">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生年月" prop="birth_year">
            <el-date-picker
              v-model="formData.birth_year"
              type="month"
              placeholder="选择月份"
              style="width: 100%"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="身份证" prop="id_card">
            <el-input v-model="formData.id_card" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入电话号码"></el-input>
          </el-form-item>
          <el-form-item label="入职日期" prop="entry_date">
            <el-date-picker
              v-model="formData.entry_date"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="离职日期">
            <el-date-picker
              v-model="formData.leave_date"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="入职属性日期" prop="entry_attr_date">
            <el-date-picker
              v-model="formData.entry_attr_date"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formData.remark" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%">
              <el-option label="在职" value="在职"></el-option>
              <el-option label="离职" value="离职"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
            <el-button @click="handleClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getEmployeeList, createEmployee, updateEmployee, deleteEmployee } from '@/api/employee';
import HistoryDialog from './components/HistoryDialog.vue';

export default {
  components: {
    HistoryDialog,
  },
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      loading: false,
      total: 0,
      pageParams: {
        skip: 1,
        limit: 10,
        status: '在职',
      },
      tabPosition: '在职',
      tableData: [],
      drawerVisible: false,
      drawerTitle: '',
      formData: {
        name: '',
        gender: '',
        birth_year: '',
        id_card: '',
        phone: '',
        entry_date: '',
        leave_date: null,
        entry_attr_date: '',
        remark: '',
        status: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        birth_year: [{ required: true, message: '请选择出生年月', trigger: 'change' }],
        id_card: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur',
          },
        ],
        phone: [
          // { required: true, message: '请输入电话号码', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号码', trigger: 'blur' },
        ],
        // entry_date: [{ required: true, message: '请选择入职日期', trigger: 'change' }],
        // entry_attr_date: [{ required: true, message: '请选择入职属性日期', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isEdit: false,
      editIndex: -1,
      historyDialogVisible: false,
      currentEmployeeId: null,
      userList: [],
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
    handleAdd() {
      this.drawerTitle = '添加员工';
      this.isEdit = false;
      this.formData = {
        name: '',
        gender: '',
        birth_year: '',
        id_card: '',
        phone: '',
        entry_date: '',
        leave_date: '',
        entry_attr_date: '',
        remark: '',
        status: '在职',
      };
      this.drawerVisible = true;
    },
    handleCommand(command, row) {
      this.currentEmployeeId = row.id;
      switch (command) {
        case 'edit':
          this.drawerTitle = '编辑员工';
          this.isEdit = true;
          this.editIndex = this.tableData.findIndex((item) => item.id === row.id);
          this.formData = { ...row };
          this.drawerVisible = true;
          break;
        case 'delete':
          this.$confirm('确认删除该员工信息吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              try {
                this.formData.operator = localStorage.getItem('UserId') || 'admin';
                await deleteEmployee(row.id);
                this.$message.success('删除成功');
                this.getList();
              } catch (error) {
                this.$message.error('删除失败：' + error.message);
              }
            })
            .catch(() => {});
          break;
        case 'history':
          this.historyDialogVisible = true;
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.drawerVisible = false;
    },
    async handleSubmit() {
      try {
        // 处理空的离职日期
        if (this.formData.leave_date === '') {
          this.formData.leave_date = null;
        }
        await this.$refs.employeeForm.validate();
        if (this.isEdit) {
          this.formData.operator = localStorage.getItem('UserId') || 'admin';
          await updateEmployee(this.formData.id, this.formData);
          this.$message.success('编辑成功');
          this.getList();
        } else {
          await createEmployee(this.formData);
          this.$message.success('添加成功');
          this.getList();
        }
        this.drawerVisible = false;
        this.$refs.employeeForm.resetFields();
      } catch (error) {
        if (error.message) {
          this.$message.error('操作失败：' + error.message);
        }
      }
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getEmployeeList(this.pageParams);
        this.tableData = (res.data.data.list || []).map((item) => ({
          id: item.id,
          name: item.name,
          gender: item.gender,
          birth_year: item.birth_year,
          id_card: item.id_card,
          phone: item.phone,
          entry_date: item.entry_date ? item.entry_date.split('T')[0] : '',
          leave_date: item.leave_date ? item.leave_date.split('T')[0] : null,
          entry_attr_date: item.entry_attr_date ? item.entry_attr_date.split('T')[0] : '',
          remark: item.remark,
          status: item.status,
        }));
        this.total = res.data.data.total || 0;
      } catch (error) {
        this.$message.error('获取列表失败：' + error.message);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageParams.skip = val;
      this.getList();
    },
    handleTabChange() {
      this.pageParams.status = this.tabPosition;
      this.getList();
    },
    handleHistory() {
      this.historyDialogVisible = true;
    },
    isAuthorizedUser() {
      const authorizedUsers = ['韩林达', '周德明', '何文卷', '陈伟锋'];
      const currentUser = localStorage.getItem('UserId') || '';
      return authorizedUsers.includes(currentUser);
    },
  },
  computed: {
    canEdit() {
      const userId = localStorage.getItem('UserId');
      const userList = JSON.parse(localStorage.getItem('userList') || '[]');
      const currentUser = userList.find((user) => user.name === userId);
      return currentUser && currentUser.editPermission;
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}

::v-deep .el-table td.el-table__cell .cell {
  white-space: normal !important;
}

.pagination-container {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}
</style>